import t from "./types";
import apiType from "../APIResponseActions/type";
import { AuthAPI, BufferAuthAPI } from "../../../Auth/requestHandler";
import { findStartDateAndEndDateForAllReports } from "../common";

const VTERM_TRANSACTIONS_ENDPOINT = "virtual-terminal/transactions";

export const getVtermConfig = () => async (dispatch) => {
  try {
    dispatch({ type: t.VTERM_SET_LOADING, payload: true });
    const response = await AuthAPI("domain", "virtual-terminal/config", "GET");
    if (response?.success === 1) {
      dispatch({ type: t.VTERM_SET_CONFIG, payload: response.data });
    } else {
      dispatch({ type: t.VTERM_SET_CONFIG, payload: null });
      if (response?.message) {
        dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response.message });
      }
    }
    dispatch({ type: t.VTERM_SET_LOADING, payload: false });
  } catch (error) {
    dispatch({ type: t.VTERM_SET_LOADING, payload: false });
    dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const getUnitToken = (suiteId) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `virtual-terminal/unit-token/${encodeURIComponent(suiteId)}`, "GET");
    if (response?.success === 1) {
      dispatch({ type: t.VTERM_SET_UNIT_TOKEN, payload: response.data });
    } else {
      dispatch({ type: t.VTERM_SET_UNIT_TOKEN, payload: null });
    }
  } catch (error) {
    dispatch({ type: t.VTERM_SET_UNIT_TOKEN, payload: null });
  }
};

export const processSale = (body) => async (dispatch) => {
  try {
    dispatch({ type: t.VTERM_SET_LOADING, payload: true });
    const response = await AuthAPI("domain", "virtual-terminal/sale", "POST", body);
    dispatch({ type: t.VTERM_SALE_RESULT, payload: response });
    if (response?.success === 1) {
      dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message || "Payment failed." });
    }
    dispatch({ type: t.VTERM_SET_LOADING, payload: false });
    return response;
  } catch (error) {
    dispatch({ type: t.VTERM_SET_LOADING, payload: false });
    dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
    return null;
  }
};

export const createCustomProduct = (body) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "virtual-terminal/product", "POST", body);
    if (response?.success === 1) {
      dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message || "Product created successfully." });
    } else {
      dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message || "Failed to create product." });
    }
    return response;
  } catch (error) {
    dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
    return null;
  }
};

export const deleteUnitToken = (suiteId) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `virtual-terminal/unit-token/${encodeURIComponent(suiteId)}`, "DELETE");
    if (response?.success === 1) {
      dispatch({ type: t.VTERM_SET_UNIT_TOKEN, payload: null });
      dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message || "Failed to delete saved card." });
    }
  } catch (error) {
    dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const getTransactions =
  (pageObj = null) =>
  async (dispatch) => {
    let response = null;
    try {
      if (pageObj?.exportData) {
        const body = {
          exportValue: true,
          timezone: pageObj.timezone,
          filterStatus: pageObj.filterStatus || "",
        };
        const { startDate, endDate } = await findStartDateAndEndDateForAllReports(pageObj);
        body.startDate = startDate;
        body.endDate = endDate;
        response = await BufferAuthAPI("domain", VTERM_TRANSACTIONS_ENDPOINT, "POST", body);
      } else if (pageObj) {
        const body = {
          exportValue: false,
          timezone: pageObj.timezone,
          filterStatus: pageObj.filterStatus || "",
        };
        const { startDate, endDate } = await findStartDateAndEndDateForAllReports(pageObj);
        body.startDate = startDate;
        body.endDate = endDate;
        response = await AuthAPI("domain", VTERM_TRANSACTIONS_ENDPOINT, "POST", body);
        if (response?.success === 1) {
          dispatch({ type: t.VTERM_SET_TRANSACTIONS, payload: response.data });
        }
      } else {
        response = await AuthAPI("domain", VTERM_TRANSACTIONS_ENDPOINT, "GET");
        if (response?.success === 1) {
          dispatch({ type: t.VTERM_SET_TRANSACTIONS, payload: response.data });
        }
      }
    } catch (error) {
      // Silently handle transaction fetch errors
      response = null;
    }

    return response;
  };

export const clearSaleResult = () => (dispatch) => {
  dispatch({ type: t.VTERM_CLEAR_SALE_RESULT });
};
